import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input, Output,
  ViewEncapsulation
} from "@angular/core";
import {
  RecommendationGroupModel,
} from "../../../models/recommendation.model";

require('./recommendation-groups-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-recommendation-groups-list-item',
  templateUrl: './recommendation-groups-list-item.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecommendationGroupsListItemComponent {

  @Input() recommendationGroup: RecommendationGroupModel;
  // @Output() onClickGroup = new EventEmitter<RecommendationGroupModel>();

  constructor() {
  }
}

